"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
Object.defineProperty(exports, "OAuthActions", {
  enumerable: true,
  get: function get() {
    return _Actions.Actions;
  }
});
Object.defineProperty(exports, "OAuthPage", {
  enumerable: true,
  get: function get() {
    return _Page.Page;
  }
});
var _Actions = require("./Actions");
var _Page = require("./Page");